import React, { Component } from 'react'
import { object } from 'prop-types'
import styles from './Curriculum.styl'
import { withContext } from '../../../utils/withContext'

class Curriculum extends Component {

	static propTypes = {
		context: object
	}

	render() {
		const { context: { i18n } } = this.props
		return (
			<section id="curriculum">
				<div className={ styles['content'] }>
					<div className={ styles.paulo }>
						<h2>{ i18n`curriculum_label` }</h2>
						<div className={ styles['results-list'] }>
							<p>{ i18n`curriculum_paulo_label_1` }</p>
							<p>{ i18n`curriculum_paulo_label_2` }</p>
							<p>{ i18n`curriculum_paulo_label_3` }</p>
							<p>{ i18n`curriculum_paulo_label_4` }</p>
							<p>{ i18n`curriculum_paulo_label_5` }</p>
						</div>
					</div>
					<div className={ styles.bottomDiv }>
						<div className={ styles.overlay } />
						<div className={ styles.imgRow }>
							<div className={ styles['results-container'] }>
								<h2>{ i18n`results_label_1` }<br />{ i18n`results_label_2` }</h2>
								<div className={ styles['results-list'] }>
									<p>{ i18n`curriculum_results_label_1` }</p>
									<p>{ i18n`curriculum_results_label_2` }</p>
									<p>{ i18n`curriculum_results_label_3` }</p>
									<p>{ i18n`curriculum_results_label_4` }</p>
									<p>{ i18n`curriculum_results_label_5` }</p>
								</div>
							</div>
						</div>
					</div>
					<img className={ styles.pauloImg } src={ 'https://s3-eu-west-1.amazonaws.com/files.apt.pt/assets/paulo_pires_apt.png' } />
				</div>
			</section>
		)
	}
}

export default withContext(Curriculum)



// WEBPACK FOOTER //
// ./src/client/website/components/Curriculum/Curriculum.js